module.exports = __webpack_public_path__ + "media/images/shared/icon-youtube-e8ecea66bbc7bad6d9936b8a69b4ae48.svg";